const e={hasLegal:!1,subHeader:null,isFullHeight:!0,header:"Oops, something went wrong. Please try again later."};function n(n={}){return Object.assign(Object.assign({},e),n)}function t(n){return e}export{n as buildViewConfig,t as getErrorViewConfig};
//# sourceMappingURL=errorViewConfig.js.map
